<template>
    <div>
        典型风采
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>